import { writable } from 'svelte/store';

export type EmeterMainMetric = 'power' | 'current';

const STORAGE_KEY = 'emeterMainMetric';

const readStoredMetric = (): EmeterMainMetric => {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored === 'power' || stored === 'current') {
			return stored;
		}
	} catch {
		// localStorage may be unavailable
	}
	return 'power';
};

/**
 * Sidepanel-only preference for which live metric is the Main-tab hero.
 * Shared across all emeter sidepanels so installers who think in amps
 * do not need to toggle every device.
 */
export const emeterMainMetric = writable<EmeterMainMetric>(readStoredMetric());

emeterMainMetric.subscribe((metric) => {
	try {
		localStorage.setItem(STORAGE_KEY, metric);
	} catch {
		// localStorage may be unavailable
	}
});

export const setEmeterMainMetric = (metric: EmeterMainMetric) => {
	emeterMainMetric.set(metric);
};
